<template>
  <div class="onboarding">
    <div class="af-header">
      <img
        class="instacash-logo"
        :src="require('@/assets/images/instacash-logo-black.svg')"
        alt="InstaCash logo"
      />
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  name: "AppLayoutOnboarding",
};
</script>

<style scoped lang="scss">
.onboarding {
  background: #f5f7fb;
  height: 100vh;

  .af-header {
    display: none;
    justify-content: center;
    align-items: center;
    height: 60px;
    background: white;
    margin: 0;

    .instacash-logo {
      height: 22px;
    }
  }
}

@media only screen and (min-width: 769px) {
  .af-header {
    display: flex !important;
  }
}
</style>
